<div class="cashier-search-wrap fast-ticket-wrap">
    <div class="input-wrap">
        <input id="searchEvent" [(ngModel)]="fastTicketId" class="form-control form-control-sm" type="text" placeholder="Search" />
        <button id="searchButton" class="btn primary small icon icon-magnifier" (click)="getFastTicket()"></button>
    </div>

</div>
